/**
 * PATH: apps/email/src/pages/KanbanComingSoonPage.tsx
 * PURPOSE: Send Email hub /kanban to the Newmark board that actually loads.
 * WHY: This hub does not mount a board, and sam.quotech.ai is not an app in this tree.
 */

const NEWMARK_KANBAN_URL = 'https://newmark.quotech.ai/kanban'

export default function KanbanComingSoonPage() {
  window.location.replace(NEWMARK_KANBAN_URL)
  return null
}
